import useDashboardAccess from "@/hooks/useDashboardAccess";
import { useReviewCapabilities } from ".";
import { hasReviewAction } from "./policy";
export function useReviewAccess() {
  const access = useDashboardAccess();
  const capabilities = useReviewCapabilities(access.isManager);
  return {
    ...access,
    capabilities,
    canRead:
      access.isManager &&
      hasReviewAction(capabilities.data?.allowedActions, "reviews.read"),
  };
}
